const TASK_VERIFIED_STATUSES = {
  NOT_VERIFIED: 'NOT_VERIFIED',
  VERIFIED_IN_DEFAULT_MODE: 'VERIFIED_IN_DEFAULT_MODE',
  VERIFIED_IN_DEBUG_MODE: 'VERIFIED_IN_DEBUG_MODE',
}

export default TASK_VERIFIED_STATUSES
